import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimpprichichwadtomumbaicab() {



  const cardData = {


     keyword: "Pimpri Chinchwad to Mumbai Cab",

  headingDescription: "Trustline Cab provides reliable Pimpri Chinchwad to Mumbai cab services with comfortable, safe, and affordable transportation for business travel, airport transfers, corporate meetings, family vacations, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium cars to suit every travel requirement. With transparent pricing, 24/7 online booking, doorstep pickup, and professional customer support, Trustline Travels is the preferred choice for hassle-free Pimpri Chinchwad to Mumbai taxi service.",

  topPlaces: [
  
    {
      title: "Andheri East",
      description: "Andheri East is a major corporate and commercial hub known for business parks, IT companies, hotels, and excellent connectivity to Mumbai Airport."
    },
    {
      title: "Lower Parel",
      description: "Lower Parel is one of Mumbai's fastest-growing business destinations, featuring corporate offices, commercial towers, and premium retail spaces."
    },
    {
      title: "SEEPZ MIDC",
      description: "SEEPZ MIDC is a leading technology and export hub, home to renowned IT companies, software firms, and electronics manufacturers."
    },
    {
      title: "Airoli IT Park",
      description: "Airoli is a prominent IT destination in Navi Mumbai, offering modern business parks and offices for leading multinational companies."
    },
    {
      title: "Chhatrapati Shivaji Maharaj International Airport",
      description: "Mumbai's international airport provides seamless domestic and international connectivity, making it a preferred destination for business and leisure travelers."
    },
    {
      title: "Juhu Beach",
      description: "Juhu Beach is one of Mumbai's most popular attractions, famous for its lively atmosphere, street food, and beautiful sunset views."
    },
      {
      title: "Bandra Kurla Complex (BKC)",
      description: "BKC is Mumbai's premier financial and commercial district, housing multinational corporations, banks, consulates, and world-class business centers."
    },
    {
      title: "Haji Ali Dargah",
      description: "Haji Ali Dargah is a renowned spiritual landmark located on an islet in the Arabian Sea, attracting visitors from around the world."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort offers stunning views of the Bandra-Worli Sea Link and is a favorite destination for sightseeing and photography."
    },
    {
      title: "Elephanta Caves",
      description: "A UNESCO World Heritage Site, Elephanta Caves is famous for its ancient rock-cut temples and magnificent sculptures dedicated to Lord Shiva."
    }
  ],





"services": [
  {
    "name": "Pimpri Chinchwad to Mumbai Airport Cab",
    "description": "Book Pimpri Chinchwad to Mumbai Airport cab for reliable airport transfers to all Mumbai airport terminals. Our service offers doorstep pickup, professional chauffeurs, flight tracking, luggage assistance, and comfortable Sedan, Ertiga, Innova Crysta, and SUV vehicles. Available 24x7 for domestic and international airport travel with transparent pricing."
  },
  {
    "name": "Pimpri to Mumbai Airport Cab Charges",
    "description": "Check Pimpri to Mumbai Airport cab charges with fixed and transparent pricing. Affordable fare options are available for Sedan, Ertiga, Innova Crysta, and SUV vehicles, making airport transfers economical without hidden costs."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai One Way Cab",
    "description": "Book Pimpri Chinchwad to Mumbai one way cab and pay only for your single journey. Ideal for airport transfers, business travel, corporate trips, family travel, and personal transportation with comfortable AC vehicles and experienced drivers."
  },
  {
    "name": "PCMC to Mumbai Taxi Service",
    "description": "Reliable PCMC to Mumbai taxi service for one-way, round-trip, airport transfer, and corporate travel. Enjoy clean vehicles, professional chauffeurs, fixed pricing, and timely pickups from any location in Pimpri Chinchwad."
  },
  {
    "name": "PCMC to Mumbai Drop Taxi Service",
    "description": "PCMC to Mumbai drop taxi service offers direct point-to-point transportation with affordable fares, comfortable vehicles, and experienced drivers for hassle-free intercity travel."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Innova Taxi Fare",
    "description": "Know Pimpri Chinchwad to Mumbai Innova taxi fare with transparent pricing for premium travel. Spacious seating, luxury interiors, and ample luggage space make Innova Crysta perfect for long-distance journeys."
  },
  {
    "name": "Chinchwad to Mumbai Airport Cab",
    "description": "Book Chinchwad to Mumbai Airport cab with timely pickup, professional chauffeur service, and direct transportation to domestic and international terminals for a stress-free airport journey."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Affordable Pune to Mumbai Ertiga cab service with spacious seating, comfortable interiors, and professional chauffeurs for airport transfers, family travel, and business trips."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab offers luxurious travel with spacious seating, extra luggage capacity, and experienced drivers for comfortable highway journeys."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Cab Booking",
    "description": "Book Pimpri Chinchwad to Mumbai cab with instant confirmation, multiple vehicle choices, transparent pricing, and reliable chauffeur service for one-way and round-trip travel."
  },
  {
    "name": "Chinchwad to Mumbai Cab",
    "description": "Reliable Chinchwad to Mumbai cab service offering safe and comfortable transportation for business meetings, airport transfers, sightseeing, and family travel."
  },
  {
    "name": "Chinchwad to Mumbai Airport Drop",
    "description": "Book Chinchwad to Mumbai Airport drop cab with punctual pickup, comfortable AC vehicles, and professional drivers to ensure timely arrival at your flight terminal."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Cab Booking Online",
    "description": "Reserve Pimpri Chinchwad to Mumbai cab booking online with instant confirmation, fixed fares, secure booking, and multiple vehicle options available 24x7."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides local, airport, and outstation taxi services with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles for reliable transportation throughout Maharashtra."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab for direct transfers to Mumbai Airport with professional chauffeurs, comfortable vehicles, and on-time pickup for domestic and international flights."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Reliable Pune Mumbai cab service available for one-way, airport transfer, business travel, sightseeing, and round-trip journeys with fixed pricing and professional drivers."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Cab",
    "description": "Book Pimpri Chinchwad to Mumbai cab for safe, affordable, and comfortable travel with Sedan, Ertiga, Innova Crysta, SUVs, and premium vehicles available throughout the day."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Taxi",
    "description": "Professional Pimpri Chinchwad to Mumbai taxi service with experienced chauffeurs, transparent fares, and reliable transportation for airport, corporate, and family travel."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Cab Service",
    "description": "Choose Pimpri Chinchwad to Mumbai cab service for dependable one-way, round-trip, airport transfer, and outstation travel with comfortable AC vehicles and affordable pricing."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Taxi Service",
    "description": "Our Pimpri Chinchwad to Mumbai taxi service offers clean vehicles, fixed pricing, professional drivers, and convenient pickup from homes, offices, hotels, and railway stations."
  },
  {
    "name": "Cab from Pimpri Chinchwad to Mumbai",
    "description": "Reserve a cab from Pimpri Chinchwad to Mumbai with flexible pickup timing, multiple vehicle categories, transparent pricing, and professional chauffeur service."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Car Rental",
    "description": "Pimpri Chinchwad to Mumbai car rental offers one-way, airport, business, sightseeing, and round-trip packages with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles."
  },
  {
    "name": "Cheap Pimpri Chinchwad to Mumbai Cab",
    "description": "Book cheap Pimpri Chinchwad to Mumbai cab for affordable intercity transportation with comfortable AC vehicles, experienced chauffeurs, and fixed pricing without hidden charges."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Taxi Fare",
    "description": "Check Pimpri Chinchwad to Mumbai taxi fare with transparent pricing for every vehicle category. Affordable fare packages are available for one-way, airport, and round-trip travel."
  },
  {
    "name": "Book Pimpri Chinchwad to Mumbai Cab Online",
    "description": "Book Pimpri Chinchwad to Mumbai cab online with instant confirmation, secure reservations, transparent pricing, and reliable 24x7 customer support."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Outstation Cab",
    "description": "Reliable Pimpri Chinchwad to Mumbai outstation cab service for comfortable long-distance travel with experienced chauffeurs, well-maintained vehicles, and flexible travel schedules."
  },
  {
    "name": "24x7 Pimpri Chinchwad to Mumbai Taxi",
    "description": "Our 24x7 Pimpri Chinchwad to Mumbai taxi service is available day and night for airport transfers, business travel, emergency transportation, and family trips."
  },
  {
    "name": "Best Pimpri Chinchwad to Mumbai Cab Service",
    "description": "Experience the best Pimpri Chinchwad to Mumbai cab service with premium vehicles, professional chauffeurs, affordable pricing, instant booking, and exceptional customer support."
  }
],

"tableData": [
  ["Pimpri Chinchwad to Mumbai Airport Cab", "Pimpri to Mumbai Airport Cab Charges"],
  ["Pimpri Chinchwad to Mumbai One Way Cab", "PCMC to Mumbai Taxi Service"],
  ["PCMC to Mumbai Drop Taxi Service", "Pimpri Chinchwad to Mumbai Innova Taxi Fare"],
  ["Chinchwad to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
  ["Pune to Mumbai Innova Cab", "Pimpri Chinchwad to Mumbai Cab Booking"],
  ["Chinchwad to Mumbai Cab", "Chinchwad to Mumbai Airport Drop"],
  ["Pimpri Chinchwad to Mumbai Cab Booking Online", "Cab Service in Pune"],
  ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
  ["Pimpri Chinchwad to Mumbai Cab", "Pimpri Chinchwad to Mumbai Taxi"],
  ["Pimpri Chinchwad to Mumbai Cab Service", "Pimpri Chinchwad to Mumbai Taxi Service"],
  ["Cab from Pimpri Chinchwad to Mumbai", "Pimpri Chinchwad to Mumbai Car Rental"],
  ["Cheap Pimpri Chinchwad to Mumbai Cab", "Pimpri Chinchwad to Mumbai Taxi Fare"],
  ["Book Pimpri Chinchwad to Mumbai Cab Online", "Pimpri Chinchwad to Mumbai Outstation Cab"],
  ["24x7 Pimpri Chinchwad to Mumbai Taxi", "Best Pimpri Chinchwad to Mumbai Cab Service"]
],






whychoose: [
  {
    WhyChooseheading: "Reliable Pimpri Chinchwad to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable cab services from Pimpri Chinchwad to Mumbai for business trips, airport transfers, and family travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from PCMC Areas",
    WhyChoosedescription: "We offer doorstep pickup from Pimpri, Chinchwad, Wakad, Nigdi, Bhosari, Hinjawadi, Akurdi, and all nearby locations."
  },
  {
    WhyChooseheading: "Professional Highway Chauffeurs",
    WhyChoosedescription: "Our experienced drivers ensure a safe, comfortable, and timely journey via the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "Enjoy competitive cab fares with complete pricing transparency and no hidden costs."
  },
  {
    WhyChooseheading: "Well-Maintained AC Fleet",
    WhyChoosedescription: "Travel in clean, air-conditioned Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Book flexible one-way cabs or round-trip packages according to your travel requirements."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Airport Travel",
    WhyChoosedescription: "Our cab service is ideal for corporate meetings, Mumbai Airport transfers, medical visits, and leisure travel."
  },
  {
    WhyChooseheading: "Quick Booking Support",
    WhyChoosedescription: "Our customer support team provides instant fare quotations and fast booking confirmation every day."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pimpri Chinchwad to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Pimpri Chinchwad to Mumbai for one-way, round-trip, airport, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Pimpri Chinchwad to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services without charging unnecessary return fares."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "You can choose from Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel needs."
  },
  {
    question: "Do you provide pickup from all PCMC locations?",
    answer: "Yes, we provide doorstep pickup from Pimpri, Chinchwad, Wakad, Hinjawadi, Nigdi, Bhosari, Ravet, Akurdi, and nearby areas."
  },
  {
    question: "Can I book a cab to Mumbai Airport?",
    answer: "Yes, we provide direct transfers to Mumbai Airport Terminal 1 and Terminal 2 from Pimpri Chinchwad."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specified during booking."
  },
  {
    question: "Is your cab service available throughout the day?",
    answer: "Yes, Trustline Travels operates 24/7 to serve customers traveling between Pimpri Chinchwad and Mumbai."
  },
  {
    question: "Can I reserve my cab in advance?",
    answer: "Yes, advance booking is recommended to ensure timely pickup and your preferred vehicle."
  },
  {
    question: "Do you provide cabs for business travel?",
    answer: "Yes, many corporate professionals rely on our cab service for meetings, conferences, and office visits in Mumbai."
  },
  {
    question: "How can I book a Pimpri Chinchwad to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, travel date, destination, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Jagtap",
    feedback: "Trustline Travels provided an excellent cab from Wakad to Mumbai. The driver reached on time, the vehicle was clean, and the journey was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali More",
    feedback: "Our pickup from Chinchwad was perfectly on schedule, and the entire trip to Mumbai was smooth and relaxing. Trustline Travels offered professional service at a reasonable price.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pimpri-chinchwad-to-mumbai-cab.webp",
  "description": "Book Pimpri Chinchwad to Mumbai cab service for safe, comfortable, and affordable travel. Trustline Travels offers one-way, round-trip, and Mumbai Airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pimpri-chinchwad-to-mumbai-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Pimpri Chinchwad to Mumbai Cab | PCMC Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pimpri Chinchwad to Mumbai cab service at affordable fares with Trustline Travels. Get one-way, round-trip, and Mumbai Airport taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pimpri chinchwad to mumbai airport cab, pimpri to mumbai airport cab charges, pimpri chinchwad to mumbai one way cab, pcmc to mumbai taxi service, pcmc to mumbai drop taxi service, pimpri chinchwad to mumbai innova taxi fare, chinchwad to mumbai airport cab, pune to mumbai ertiga cab, Pimpri Chinchwad to Mumbai Cab, PCMC to Mumbai cab, pimpri to mumbai taxi, chinchwad to mumbai taxi, mumbai airport cab from pcmc, one way cab from pimpri to mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/36.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimpprichichwadtomumbaicab;